<template>
  <div>
    <EmptyModal
      v-if="modalData"
      :onModalClose="() => modalData = null"
      :onModalAccept="() => modalData = null"
    >
      <slot>
        <div v-if="modalData?.file?.ext === 'xlsx'">
          <xlsx-read :file="modalData?.file?.xlsFile">
            <xlsx-json>
              <template #default="{collection}">
<!--                {{ collection }}-->
                <div>
                  <table v-if="collection && collection.length" class="table table-sm table-striped mt-1">
<!--                    <thead>-->
<!--                    <tr>-->
<!--                      <th v-for="t in Object.values(collection[0])">{{ t }}</th>-->
<!--                    </tr>-->
<!--                    </thead>-->
                    <tbody>
                    <tr v-for="(c, i) in collection">
                      <td v-for="v in Object.values(c)">{{ v }}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </template>
            </xlsx-json>
          </xlsx-read>
        </div>
        <div v-if="modalData?.file?.ext === 'pdf'" class="pdf_preview">
          <p class="text-center">{{ modalData.file.filePage }} / {{ modalData.file.totalPages }}</p>
<!--          <pdf-->
<!--            :src="modalData.file.fileLink"-->
<!--            @num-pages="modalData.file.totalPages = $event"-->
<!--            :page="modalData.file.filePage"-->
<!--          ></pdf>-->
          <p>PDF module</p>
          <div class="flex justify-content-center mb-2">
            <button @click="nextPage(true)" class="btn btn-default"><</button>
            <button @click="nextPage()" class="btn btn-default">></button>
          </div>
        </div>
        <div class="mt-2">
          <a :href="modalData.file.fileLink" target="_blank">File link</a>
        </div>
      </slot>
    </EmptyModal>

    <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>

    <div v-if="false && modalData?.file" class="pdf_preview">
      <p class="text-center">{{ modalData.file.filePage }} / {{ modalData.file.totalPages }}</p>
      <pdf
        :src="modalData.file.fileLink"
        @num-pages="modalData.file.totalPages = $event"
        :page="modalData.file.filePage"
      ></pdf>
      <div class="flex justify-content-center">
        <button @click="nextPage()" class="btn btn-default"><</button>
        <button @click="nextPage(true)" class="btn btn-default">></button>
      </div>
    </div>

    <template v-if="!loading">
      <template v-if="!records.length">
        <p>файлов не найдено</p>
      </template>
      <div class="flex flex-wrap">
        <div v-for="r in records" class="flex_block">
          <div class="preview_block">
            <div class="extension" v-if="r.ext">{{ r.ext }}</div>
            <template v-if="!r.fileLink">
              <LoadingButton
                title='<i class="icon-fa icon-fa-refresh"/>'
                :loading="btnLoading[r.Key]"
                :color="$constants.SUCCESS_COLOR"
                :onClick="() => getFile(r)"
                className="btn btn-default"
              />
            </template>
            <template v-else>
              <template v-if="extensionTypes.image.includes(r.ext)">
                <img :src="r.fileLink" alt="">
              </template>
              <template v-else-if="r.ext.toLowerCase() === 'xlsx'">
                <div @click="openModal(r)">
                  <img src="/assets/img/file_preview.png" alt="">
                </div>
              </template>
              <template v-else-if="r.ext.toLowerCase() === 'pdf'">
                <div @click="openModal(r)">
                  <pdf :src="r.fileLink"
                       @num-pages="r.totalPages = $event"
                       :page="r.filePage"
                  />
                </div>
              </template>
              <template v-else>
                <a :href="r.fileLink" target="_blank">File link</a>
              </template>
            </template>
          </div>
          <div>
            <p>{{ r.fileName }}</p>
            <p class="text-muted">{{ printDate(r.LastModified) }}</p>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>

import api from "@/api";
import moment from "moment";
import LoadingButton from "@/components/buttons/LoadingButton.vue";
// import pdf from 'vue-pdf'
import EmptyModal from "@/components/modals/EmptyModal.vue";
import {XlsxRead, XlsxJson} from "vue-xlsx";

export default {
  components: {
    LoadingButton,
    // pdf,
    EmptyModal,
    XlsxRead,
    XlsxJson,
  },
  props: ['path'],
  data() {
    return {
      xlsFile: null,
      // selectedSheet: 'drugs',
      modalData: null,
      loading: true,
      btnLoading: {},
      records: null,
      extensionTypes: {
        image: ['jpg', 'png', 'jpeg']
      }
    }
  },
  async created() {
    this.getRecords();
  },
  methods: {
    nextPage(minus = false) {
      if (minus) {
        if (+this.modalData.file.filePage === 1) return;
        this.modalData.file.filePage -= 1;
      } else {
        if (+this.modalData.file.filePage === +this.modalData.file.totalPages) return;
        this.modalData.file.filePage += 1;
      }
      this.modalData = {...this.modalData}
    },
    async openModal(record) {
      if (record.ext === 'xlsx') {
        let blob = await fetch(record.fileLink).then(r => r.blob());
        console.log(blob);
        record.xlsFile = blob;
      }
      this.modalData = {
        file: record
      };
    },
    async getFile(record) {
      this.btnLoading[record.Key] = true;
      this.btnLoading = {...this.btnLoading};
      const {data} = await api.post('/filestorage/list', {
        action: 'file',
        key: record.Key
      });
      // const data = {
      //   success: true,
      //   record: {fileLink: 'http://127.0.0.1:8000/storage/drugs.xls'}
      // };
      if (data.success && data.record) {
        const index = this.records.findIndex((r) => r.Key === record.Key);
        this.records[index].fileLink = data.record.fileLink;
        this.records[index].filePage = 1;
        this.records[index].totalPages = 0;
        this.records = [...this.records];
      }
      this.btnLoading[record.Key] = false;
    },
    async getRecords() {
      this.loading = true;
      const {data} = await api.post('/filestorage/list', {
        action: 'filesList',
        path: this.path
      })
      if (data.success) {
        const records = (data.records || []).reduce((acc, r) => {
          const name = r.Key.split('/').pop();
          const timestamp = moment(r.LastModified).unix();
          const ext = name.split('.').pop();
          acc.push({...r, fileName: name, timestamp, ext});
          return acc;
        }, []);
        this.records = _.orderBy(records, 'timestamp', 'desc')
      }
      this.loading = false;
    }
  }
}

</script>

<style scoped>
.flex_block {
  border: 1px solid lightgray;
  padding: 3px;
  margin: 3px;
  max-width: 25%;
  min-width: 120px;
  min-height: 150px;
  display: flex;
  flex-direction: column;
}

.preview_block {
  position: relative;
}

.preview_block .extension {
  position: absolute;
  background-color: #343a52;
  top: 0;
  right: 0;
  color: #fff;
  padding: 1px 5px;
  text-transform: uppercase;
  font-size: 12px;
  opacity: .7;
}

.flex_block div:nth-of-type(1) {
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.flex_block p {
  font-size: 12px;
  margin-bottom: 0;
}

.flex_block p:nth-of-type(1) {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.flex_block img {
  width: 100%;
}

.pdf_preview {
  width: 100vw;
}

table.table th,
table.table td {
  font-size: 9px;
  padding: 3px;
}
</style>
